import { getTrackingHeadersMap } from "./getTrackingHeaders";
import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { IBillNoFreight } from "../models/bnfException";
import { throwApiError } from "./apiError";

/**
 * GET API call using Axios
 */

export const getBillNoFreightEditViewAPI = async (osdNumber: number | string): Promise<IBillNoFreight | undefined> => {
  try {
    // Get static headers from map
    const staticHeaders = getTrackingHeadersMap(ApiType.BNF_EDIT_VIEW) ?? {};
    // Add dynamic OSD-Exception-Number
    const headers = {
      ...staticHeaders,
      "OSD-Exception-Number": osdNumber.toString(),
    };
    const response = await axios.get(`${getUrl(ApiType.BNF_EDIT_VIEW)}/${osdNumber}`, { headers });
    return response?.data ?? {};
  } catch (error) {
    throwApiError(error, ErrorMessages.bnfEntryDetailsAPIError, { badRequestOrder: "errorsFirst" });
  }
};
